import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Global session-expiry handling (TJ-006): if an authenticated request returns 401 mid-session,
// send the owner back to login with a clear reason instead of surfacing a raw "Not authenticated".
// Auth probes (me/login/mfa/logout) are excluded so normal logged-out checks don't trigger a redirect.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    // Step-up re-verification returns 401 for a wrong password/code; that is NOT a session expiry.
    const isAuthProbe = ["/auth/me", "/auth/login", "/auth/mfa", "/auth/logout", "step-up"].some((p) => url.includes(p));
    if (status === 401 && !isAuthProbe && typeof window !== "undefined" && !window.location.pathname.startsWith("/login")) {
      window.location.assign("/login?expired=1");
    }
    return Promise.reject(error);
  },
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fmtMoney(value, currency = "INR") {
  const n = Number(value);
  if (Number.isNaN(n)) return "—";
  const symbol = currency === "USD" ? "$" : currency === "USDT" ? "" : "₹";
  const formatted = new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(n));
  const suffix = currency === "USDT" ? " USDT" : "";
  return `${n < 0 ? "-" : ""}${symbol}${formatted}${suffix}`;
}

export function fmtNum(value, digits = 2) {
  const n = Number(value);
  if (Number.isNaN(n)) return "—";
  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(n);
}
